import { z } from 'zod'

import { Location } from '@/types/location'
import { BCDCity, BCDCityZ, CountryStateZ } from '@/types/lookup'

import { getGGClient, RequestOverrides } from './GetGoingClient'

export async function getCountryStates(country_code: string, overrides?: RequestOverrides) {
	return getGGClient()
		.request('GET', 'states', {
			params: { country_code },
			responseSchema: CountryStateZ.array(),
			...overrides,
		})
		.then((r) => r.data)
}

getCountryStates.queryKey = (country_code: string) => ['states', country_code]

export async function searchCarCities(terms: string, overrides?: RequestOverrides) {
	return getGGClient()
		.request('GET', 'cars/search_city', {
			responseSchema: BCDCityZ.array(),
			params: { search: terms },
			...overrides,
		})
		.then((r) => r.data)
}

export async function addCarLocation(location: BCDCity, state: string, overrides?: RequestOverrides) {
	return getGGClient()
		.request('POST', 'cars/city', {
			requestSchema: BCDCityZ.extend({ state: z.string() }),
			data: { ...location, state },
			...overrides,
		})
		.then((r) => {
			return r.data as unknown as Location
		})
}
